"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _getLimitsText = _interopRequireDefault(require("../../../../../calendarAppDisplayFormatting/getLimitsText"));
var _getInfoText = _interopRequireDefault(require("../../../../../calendarAppDisplayFormatting/getInfoText"));
var _getTitleText = _interopRequireDefault(require("../../../../../calendarAppDisplayFormatting/getTitleText"));
var _formatDateRange = _interopRequireDefault(require("../../../../../utils/formatDateRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Note Shared with ApplicationList and also with ApplicationEdit
const Title = _styledComponents.default.p`
  font-weight: 500;
  font-size: 1rem;
  display: block;
  text-align: center;
  color: red;
  // text-transform: uppercase;
  margin-bottom: 0.3rem;
`;
const SubTitle = (0, _styledComponents.default)(Title)`
  font-weight: 300;
  font-size: 0.9rem;
`;
const P = _styledComponents.default.p`
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
  text-indent: 0%;
  text-align: center;
`;
const PL = (0, _styledComponents.default)(P)`
  color: blue;
`;
const PB = (0, _styledComponents.default)(P)`
  font-weight: 800;
`;
const PI = (0, _styledComponents.default)(P)`
  font-style: italic;
`;
const Stretch = (0, _styledComponents.default)(PB)`
  display: flex;
  justify-content: space-between;
  span:first-child {
    text-align: left;
  }
  span:last-child {
    text-align: right;
  }
`;
var _ref = /*#__PURE__*/_react.default.createElement("span", null, "Venue: ");
var _ref2 = /*#__PURE__*/_react.default.createElement("span", null, "Organiser: ");
var _ref3 = /*#__PURE__*/_react.default.createElement(P, null, "Entries accepted at the competition.");
var _ref4 = /*#__PURE__*/_react.default.createElement(PB, null, "No entries accepted on the day.");
var _ref5 = /*#__PURE__*/_react.default.createElement(PI, null, "More details:");
class Preview extends _react.Component {
  render() {
    const application = this.props.application;
    const infoText = (0, _getInfoText.default)(application);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Title, null, application.competitionName), (0, _getTitleText.default)(application).map((line, i) => /*#__PURE__*/_react.default.createElement(SubTitle, {
      key: i
    }, line)), /*#__PURE__*/_react.default.createElement(P, null, application.club1.clubName + (application.club2 ? ' & ' + application.club2.clubName : '')), /*#__PURE__*/_react.default.createElement(P, null, _ref, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'blue'
      }
    }, application.site.location || '(tbc)')), /*#__PURE__*/_react.default.createElement(P, null, _ref2, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'blue'
      }
    }, application.organiserName || '(tbc)'), !application.publishedEmail ? null : /*#__PURE__*/_react.default.createElement("span", null, " (", application.publishedEmail, ")")), /*#__PURE__*/_react.default.createElement(P, null, (0, _getLimitsText.default)(application)), application.onDayEntriesAccepted ? _ref3 : _ref4, application.entryFees.map((line, i) => /*#__PURE__*/_react.default.createElement(P, {
      key: i
    }, line)), !(application.protestCharity && application.protestCharity.length) ? null : /*#__PURE__*/_react.default.createElement(P, null, "Fees for rejected protests donated to ", application.protestCharity), /*#__PURE__*/_react.default.createElement(P, null, "Sat Nav ", application.site.postCode), /*#__PURE__*/_react.default.createElement(P, null, !application.site.mapReference ? null : /*#__PURE__*/_react.default.createElement("span", null, "Map ", application.site.mapReference, " Ref ", application.site.gridReference), !application.site.what3words ? null : /*#__PURE__*/_react.default.createElement("span", null, " What3Words ", application.site.what3words)), !infoText.length ? null : [_ref5, infoText.map((line, i) => /*#__PURE__*/_react.default.createElement(PI, {
      key: i
    }, line))]);
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Preview, "partialQueries", {
  Application: {
    id: true,
    competitionName: true,
    competitionTitle: true,
    isDouble: true,
    organiserName: true,
    entriesTo: true,
    publishedEmail: true,
    onlineEntriesAvailable: true,
    entriesSite: true,
    onDayEntriesAccepted: true,
    protestCharity: true,
    infoSite: true,
    competitionDates: true,
    club1: {
      clubName: true
    },
    club2: {
      clubName: true
    },
    numberOfDays: true,
    entryLimits: true,
    entryFees: true,
    info: true,
    applicationSpecials: {
      id: true,
      specialLabel: true,
      calendarDateID: true,
      dayNumber: true,
      useInSubtitle: true
    },
    applicationTiers: {
      id: true,
      useStandardFees: true,
      enhancedFeeTbd: true,
      enhancedFee: true,
      tierDescription: true
    },
    applicationRacing: {
      id: true,
      calendarDateID: true,
      tierDescription: true,
      isRaceStartDay: true
    },
    site: {
      id: true,
      location: true,
      postCode: true,
      mapReference: true,
      gridReference: true,
      what3words: true,
      county: {
        countyName: true
      }
    }
  }
});
var _default = exports.default = Preview;